<template>
  <div class="home">
    <el-container>
      <el-header class="b-head" v-setHeight ref="head" id="anchor-head">
        <el-row class="b-head-name">
          <el-col :span="12" class="b-hello">
              <span class="hello">您好，我是</span>
          </el-col>
          <el-col :span="12" class="b-myname">
              <span class="myname">蔡廷灿</span>
          </el-col>
        </el-row>
        <!-- <el-menu 
          :default-active="activeIndex" 
          class="el-menu" 
          mode="horizontal" 
          @select="handleSelect"
          text-color="#fff"
          active-text-color="#ba4539">
          <el-menu-item 
            v-for="(item, index) in menu" 
            :index="String(index)" 
            :key="item.name">
            {{item.name}}
          </el-menu-item>
        </el-menu> -->
        <div class="b-head-pros">
          <p>{{yiyan}}</p>
          <span class="b-pros">
              前端开发
          </span>
        </div>
        <ul class="b-head-contact" >
          <li class="b-contact" v-for="item in contact" :key="item.icon">
            <a 
              class="iconfont"
              target="blank"
              :href="item.url"
              :class="item.icon"></a>
          </li>
        </ul>
        <i class="el-icon-loading" style="font-size:2.5rem;" v-show="load"></i>
        <el-button class="b-head-enter" type="info" @click="get" v-show="!load" circle>Enter</el-button>
      </el-header>
      <el-main class="b-main">
        <div id="anchor-about">
          <el-row class="card-one">
            <el-col :span="24" :md="12" class="b-self">
              <div class="b-title">
                <i class="iconfont icon-yinhao"></i>
                <span class="cn">关于我</span>
                <span class="en">About Me</span>
              </div>
              <div class="b-content">
                <el-row class="item" v-for="item in selfCard" :key="item.name">
                  <el-col :span="3">
                    <div class="name">
                      {{item.name}}
                    </div>
                  </el-col>
                  <el-col :span="20" :offset="1" :md="item.md">
                    <el-tooltip class="value hidden-md-and-up" effect="dark " :content="item.value" placement="top-start">
                      <span>{{item.value}}</span>
                    </el-tooltip>
                    <div class="value hidden-sm-and-down">{{item.value}}</div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="24" :md="12" class="b-ucan">
              <div class="b-title">
                <i class="iconfont icon-yinhao"></i>
                <span class="cn">技能</span>
                <span class="en">Technical Ability</span>
              </div>
              <div class="b-content">
                <el-row class="item" v-for="item in ucanCard" :key="item.name">
                  <el-col :span="3" :offset="1">
                    <div class="name">
                      {{item.name}}
                    </div>
                  </el-col>
                  <el-col :span="20" :md="item.md" >
                    <el-tooltip class="value hidden-md-and-up" effect="dark " :content="item.value" placement="top-start">
                      <span>{{item.value}}</span>
                    </el-tooltip>
                    <div class="value hidden-sm-and-down">{{item.value}}</div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
          <el-row class="card-two">
            <div class="circle"></div>
            <el-col :span="0" :sm="6" class="pic"></el-col>
            <el-col :span="24" :sm="16" class="think">
              <span class="iconfont icon-yinhao iconleft" ></span>
              <span class="fline">踏入前端2年，目前向前端工程师发展</span>
              <span class="sline">有点强迫症，<span class="stress">虽</span>非UI、架构，<span class="stress">但</span></span>
              <span class="tline">除了功能，对UI、UE及项目架构有一定要求</span>
              <span class="iconfont icon-yinhao iconright"></span>
            </el-col>
          </el-row>
        </div>
        <div id="anchor-exp">
          <el-row class="card-three">
            <el-col :span="24" class="card-title">
              <span>工作项目概览</span>
            </el-col>
            <el-col id="gallery" :span="24" class="gallery"></el-col>
          </el-row>
        </div>
        <div id="anchor-work">
          <el-row class="card-four">
            <el-col :span="24" class="card-title">
              参与项目简述
            </el-col>
            <el-col :span="24" :md="8" class="intro" v-for="item in workCard" :key="item.name">
              <div class="work-card">
                <div class="work-card-head">
                  <span class="title">{{item.name}}</span>
                  <div class="tags">
                    <el-tag size="mini" v-for="tag in item.tag" :key="tag" class="tag">{{tag}}</el-tag>
                  </div>
                  <span class="badge">{{item.person?"个人":"公司"}}</span>
                </div>
                <div class="work-card-main">
                  {{item.content}}
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <el-row class="card-five">
          <div class="circle"></div>
          <el-col :span="0" :sm="2" class="holder"></el-col>
          <el-col :span="24" :sm="16" class="think">
            <span class="iconfont icon-yinhao iconleft" ></span>
            <span class="fline">希望加入更加强大的团队</span>
            <span class="sline">学习积累更多的<span class="stress">知识</span>与<span class="stress">经验</span></span>
            <span class="tline">提升自我水平，更大限度贡献于团队！</span>
            <span class="iconfont icon-yinhao iconright"></span>
          </el-col>
          <el-col :span="0" :sm="6" class="pic"></el-col>
        </el-row>
        <el-row class="end-title">
          <el-col :span="24" class="card-title">
            终了
          </el-col>
        </el-row>
      </el-main>
      <el-footer class="b-foot" height="250px">
        <el-row class="contact">
          <el-col :sm="6" class="hidden-xs-only holder"></el-col>
          <el-col :span="24" :sm="12" class="content">
            <p>
              @2018 Build by Tingcan Cai （ 蔡廷灿 ）
            </p>
            <p>
              <i class="iconfont icon-phone"></i>15018504589
            </p>
            <p>
              <i class="iconfont icon-youxiang"></i>495799915@qq.com
            </p>
          </el-col>
          <el-col :sm="6" class="hidden-xs-only holder"></el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="thank">特别鸣谢</el-col>
          <el-col :span="24" :sm="6" v-for="item in links" :key="item.name" class="link">
            <a :href="item.url" target="blank">{{item.name}}</a>
          </el-col>
        </el-row>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import 'lightgallery.js/dist/js/lightgallery'
import OCask from 'ocask.js'
import Data from '../assets/data/data.json'
export default {
  data() {
    return {
      // 一言
      yiyan:"",
      // 导航
      menu: [
        {
          //个人简介
          name: "About Me",
          to: "head"
        },
        {
          // 能力卡
          name: "Capability Card",
          to: "about"
        },
        {
          // 项目经验
          name: "Experience",
          to: "exp"
        },
        {
          // 求职意向
          name: "Work Target",
          to: "work"
        }
      ],
      // 默认选中导航
      activeIndex: "1",
      // 资源加载中
      load: true,
      // 链接
      contact: [
        {
          icon: "icon-github",
          url: "https://github.com/ctc1995/"
        },
        {
          icon: "icon-rss",
          url: "https://www.cnblogs.com/czaiz/"
        }
      ],
      // 个人卡片
      selfCard: [],
      // 技能卡片
      ucanCard: [],
      // 项目卡片
      workCard:[],
      // 友链
      links:[
        {
          "name":"Vue",
          "url":"https://github.com/vuejs/vue"
        },
        {
          "name":"ElementUI",
          "url":"https://github.com/ElemeFE/element"
        },
        {
          "name":"lightgallery.js",
          "url":"https://github.com/sachinchoolur/lightgallery.js"
        },
        {
          "name":"iconfont",
          "url":"http://www.iconfont.cn"
        }]
    };
  },
  methods: {
    get() {
      document.getElementsByClassName("home")[0].style.overflow = "auto";
      this.goAnchor(`#anchor-about`);
    },
    // 导航选中事件
    handleSelect(key, keyPath) {
      this.$router.push(`/home/#anchor-${this.menu[key].to}`);
      this.goAnchor(`#anchor-${this.menu[key].to}`);
      if (key > 0) {
        this.load = false;
        document.getElementsByClassName("home")[0].style.overflow = "auto";
      }
      // console.log(key, keyPath);
    },
    goAnchor(anchor) {
      let el = document.querySelectorAll(anchor);
      // 获取需要滚动到的位置
      let total = el[0].offsetTop;
      // 当前滑动条位置
      let distance = document.getElementsByClassName("home")[0].scrollTop;
      // 平滑滚动，时长500ms，每10ms一跳，共50跳
      let step = total / 50;
      if (anchor == "#anchor-about") {
        total *= 0.3;
      }
      if (total > distance) {
        smooth(1);
      } else {
        let newTotal = distance - total;
        step = newTotal / 50;
        smooth(0);
      }
      function smooth(direction) {
        // direction为1时向下滑动， 0时向上滑动
        if (direction) {
          if (document.getElementsByClassName("home")[0].scrollTop < total) {
            document.getElementsByClassName("home")[0].scrollTop += step;
            setTimeout(() => {
              smooth(1);
            }, 10);
          } else {
            document.getElementsByClassName("home")[0].scrollTop = total;
          }
        } else {
          if (document.getElementsByClassName("home")[0].scrollTop > total) {
            document.getElementsByClassName("home")[0].scrollTop -= step;
            setTimeout(() => {
              smooth(0);
            }, 10);
          } else {
            document.getElementsByClassName("home")[0].scrollTop = total;
          }
        }
      }
    },
    complete(){
      if (document.readyState === "complete") {
        this.load = false;
      }
    }
  },
  mounted() {
    var oc = new OCask({
      container: document.getElementById("gallery"),
      baseHeight: 200,
      imgArr: [
        "https://raw.githubusercontent.com/ctc1995/resume/master/static/form-main.jpg",
        "https://raw.githubusercontent.com/ctc1995/resume/master/static/form-main-sm.jpg",
        "https://raw.githubusercontent.com/ctc1995/resume/master/static/form-user.gif",
        "https://raw.githubusercontent.com/ctc1995/resume/master/static/ruled.jpg",
        "https://raw.githubusercontent.com/ctc1995/resume/master/static/merp-login.gif",
        "https://raw.githubusercontent.com/ctc1995/resume/master/static/merp-main.gif",
        "https://raw.githubusercontent.com/ctc1995/resume/master/static/merp-check.gif",
        "https://raw.githubusercontent.com/ctc1995/resume/master/static/jege-index.jpg",
        "https://raw.githubusercontent.com/ctc1995/resume/master/static/jege-m.jpg",
        "https://raw.githubusercontent.com/ctc1995/resume/master/static/form-desin.jpg",
        "https://raw.githubusercontent.com/ctc1995/resume/master/static/shop-index.jpg",
        "https://raw.githubusercontent.com/ctc1995/resume/master/static/shop-m.jpg"
      ],
      isGap: false,
      imgClass: "imgItem",
      responsive: true,
      lightGallery: true,
      lightGalleryConf: {
        speed: "100"
      }
    });
    
    oc.getImgs();
    this.selfCard = Data.selfCard;
    this.ucanCard = Data.ucanCard;
    this.workCard = Data.workCard;
    this.yiyan = Data.yiyan[parseInt(Math.random()*Data.yiyan.length)]
    document.onreadystatechange = this.complete;
  },
  directives: {
    setHeight: {
      bind: function(el) {
        el.style.height = window.innerHeight + "px";
        window.onresize = () => {
          el.style.height = window.innerHeight + "px";
        };
      },
      update: function(el) {
        el.style.height = window.innerHeight + "px";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./home.scss";
</style>


// WEBPACK FOOTER //
// src/components/home.vue